import { mapGetters, mapActions } from 'vuex'

const moduleName = 'repx'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff'
    })
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem', 'saveSnapshot', 'clearSnapshots', 'setReturnRoute']),
    ...mapActions('quotes', { setQuoteReturnRoute: 'setReturnRoute', editStoreQuote: 'editStoreItem' })
  }
}
